import { Channel } from '@/Enums/Channel.enum';
import { IImpressionCalculation } from '@/Interfaces/Forecaster';
import Impressions from '@/components/Forecast/Estimation/Impressions';
import Reach from '@/components/Forecast/Estimation/Reach';
import { LOADING } from '@/constants/forecaster';
import { numberToUsFormat } from '@/helpers/valueFormatter/numberFormatter.helpers';
import EstimationDatePicker from '../components/EstimationDatePicker';

interface IProps {
  data: IImpressionCalculation | null;
  tabName: string;
  showDatePicker?: boolean;
  showReach?: boolean;
  currentChannel?: Channel;
}

const BasicTab = ({ tabName, data, showDatePicker, showReach = true, currentChannel }: IProps) => (
  <div className='flex w-full h-full flex-col gap-3 justify-evenly items-center'>
    {showDatePicker ? <EstimationDatePicker /> : null}
    <Impressions
      tabName={tabName}
      value={data ? numberToUsFormat(data.impressions) : LOADING}
      currentChannel={currentChannel}
    />
    {showReach ? <Reach tabName={tabName} value={data ? numberToUsFormat(data.reach ?? 0) : LOADING} /> : null}
  </div>
);

export default BasicTab;
